<template>
  <div class="flex h-screen flex-col items-center justify-center">
    <h2 class="mb-4 text-3xl font-bold text-gray-800">
      {{ t('errorFallbackUnauthorized.title') }}
    </h2>
    <p class="mb-4 text-gray-600">{{ t('errorFallbackUnauthorized.message') }}</p>
    <small class="mb-4 text-gray-500">{{ dynamicMessageSecondary }}</small>
    <Button @click="goToLoginPage">{{ t('errorFallbackUnauthorized.button') }}</Button>
  </div>
</template>

<script setup lang="ts">
import { useLogout } from '@/composable/useLogout'
import { useLocalization } from '@/plugins/localization'
import { routePaths } from '@/router/router-constants'
import { computed, onMounted, onUnmounted, ref } from 'vue'
const { t } = useLocalization()
const logout = useLogout()
const countdown = ref(5)
const intervalId = ref<NodeJS.Timeout | null>(null)

const dynamicMessageSecondary = computed(() =>
  t('errorFallbackUnauthorized.messageSecondary', { seconds: countdown.value }),
)

const updateCountdown = () => {
  if (countdown.value > 0) {
    countdown.value -= 1
  } else {
    goToLoginPage()
  }
}

const goToLoginPage = () => {
  logout()
  window.location.href = routePaths.login
}

onMounted(() => {
  intervalId.value = setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  if (intervalId.value !== null) {
    clearInterval(intervalId.value)
  }
})
</script>
